import React from "react";
import classNames from "classnames";

type Props = {
  count: number;
  total: number;
  percentage: number;
  collapse?: boolean;
  showExplanatoryText?: boolean;
  explanatoryText?: string;
  partialCount?: number;
  partialPercentage?: number;
};

const LearningOutcomesCount: React.FC<Props> = (props) => {
  return (
    <div>
      <div className="text-acc-15px font-acc-700 leading-none tracking-default text-grey-90">{"Fully met"}</div>
      <div
        className={classNames("mb-4 mt-1 flex flex-row items-end", {
          "mb-0": props.collapse,
        })}
      >
        <div className="text-acc-34px font-acc-700 leading-none tracking-[-0.5] text-green-light-text">
          {props.count}
        </div>
        <div className="mb-1 text-acc-15px font-acc-700 leading-none tracking-default text-grey-60">
          &nbsp;{`/ ${props.total}`}
        </div>
        <div className="mb-1 text-acc-15px font-acc-700 leading-none tracking-default text-grey-90">
          &nbsp;{`(${props.percentage}%)`}
        </div>
        {props.showExplanatoryText && (
          <div className="mb-1 text-acc-15px font-acc-700 leading-none tracking-default text-grey-90">
            &nbsp;{props.explanatoryText ?? ""}
          </div>
        )}
      </div>
      {props.partialCount !== undefined && (
        <>
          <div className="text-acc-15px font-acc-700 leading-none tracking-default text-grey-90">{"Partially met"}</div>
          <div
            className={classNames("mb-4 mt-1 flex flex-row items-end", {
              "mb-0": props.collapse,
            })}
          >
            <div className="text-acc-34px font-acc-700 leading-none tracking-[-0.5] text-orange-50">
              {props.partialCount}
            </div>
            <div className="mb-1 text-acc-15px font-acc-700 leading-none tracking-default text-grey-60">
              &nbsp;{`/ ${props.total}`}
            </div>
            <div className="mb-1 text-acc-15px font-acc-700 leading-none tracking-default text-grey-90">
              &nbsp;{`(${props.partialPercentage}%)`}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default LearningOutcomesCount;
